import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminGirisYap } from '../services/api';

export default function AdminLogin() {
  const [kullaniciAdi, setKullaniciAdi] = useState('');
  const [sifre, setSifre] = useState('');
  const [hata, setHata] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);
  const navigate = useNavigate();

  const girisYap = (e) => {
    e.preventDefault();
    setHata(''); setYukleniyor(true);
    adminGirisYap(kullaniciAdi, sifre)
      .then((res) => {
        localStorage.setItem('adminId', res.data.id);
        localStorage.setItem('adminKullaniciAdi', res.data.kullaniciAdi);
        navigate('/admin');
      })
      .catch((err) => setHata(err.response?.data?.hata || 'Giriş yapılamadı.'))
      .finally(() => setYukleniyor(false));
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <form onSubmit={girisYap} className="kart" style={{ width: 340 }}>
        <h2 style={{ marginTop: 0, color: '#1e2a3a' }}>Admin Girişi</h2>
        {hata && <div className="hata-kutu">{hata}</div>}
        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Kullanıcı Adı</label>
          <input value={kullaniciAdi} onChange={(e) => setKullaniciAdi(e.target.value)} required />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: '#6b7684', display: 'block', marginBottom: 6 }}>Şifre</label>
          <input type="password" value={sifre} onChange={(e) => setSifre(e.target.value)} required />
        </div>
        <button type="submit" disabled={yukleniyor} className="btn btn-vurgu" style={{ width: '100%' }}>
          {yukleniyor ? 'Giriş yapılıyor...' : 'Giriş Yap'}
        </button>
      </form>
    </div>
  );
}
